import { render, staticRenderFns } from "./MindsetReportsAdminDashboard.vue?vue&type=template&id=2b807e23&"
import script from "./MindsetReportsAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./MindsetReportsAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports